import List from '@alltrails/shared/icons/List';
import { COLOR_INTERACTIVE_PRIMARY } from '@alltrails/shared/denali/tokens';
import { modalRoadblock } from '@alltrails/shared/utils/modalFunnelUtils';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import ActionBarItem from '../../../../components/ActionBarItem';

const createReactClass = require('create-react-class');

const CopyToListsButton = createReactClass({
  getInitialState() {
    return {
      copyToListText: this.props.intl.formatMessage({ defaultMessage: 'Copy to my lists' }),
      allowCopy: true
    };
  },
  handleCopyListClick(e) {
    if (!this.props.currentUser) {
      const returnToUrl = LanguageSupportUtil.wrapUrlSafe(window.location.pathname + window.location.search, this.props.languageRegionCode);
      modalRoadblock('signup', 'explore-trail-list-copy', returnToUrl, this.props.languageRegionCode);
      return false;
    }

    if (!this.state.allowCopy || this.props.disabled) {
      return false;
    }

    this.setState({ copyToListText: this.props.intl.formatMessage({ defaultMessage: 'Copying...' }), allowCopy: false });
    ServerCommunicationUtil.postApiEndpoint(
      `/api/alltrails/lists/${this.props.listId}/copy`,
      {},
      function (data) {
        this.setState({ copyToListText: this.props.intl.formatMessage({ defaultMessage: 'Successfully copied' }) });
        if (data.lists && data.lists[0]) {
          window.location = LanguageSupportUtil.wrapUrlSafe(`/lists/${data.lists[0].slug}`, this.props.languageRegionCode);
        }
      }.bind(this),
      function (err) {
        console.log(err);
        this.setState({ copyToListText: this.props.intl.formatMessage({ defaultMessage: 'Error occurred' }) });
      }.bind(this),
      function () {}
    );
  },
  render() {
    return (
      <ActionBarItem
        title={this.state.copyToListText}
        icon={<List color={COLOR_INTERACTIVE_PRIMARY} />}
        onClick={this.handleCopyListClick}
        disabled={this.props.disabled}
        testId="copy-to-list-action"
      />
    );
  }
});

export { CopyToListsButton };
